import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TagsDashboardQueryKeys } from "modules/TagsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteTagPayload = {
  id: number;
};

export const useDeleteTagMutation = () =>
  useTypedMutation<DeleteTagPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/tags/delete", payload, ENV.systemBaseURL);
    },
    onSuccess: ({ id }) => {
      const tags = typedQueryClient.getQueryData(TagsDashboardQueryKeys.tags);
      if (!tags?.length) return;

      const tagIdx = tags.findIndex(tag => tag.id === id);
      if (tagIdx === -1) return;

      typedQueryClient.setQueryData(TagsDashboardQueryKeys.tags, tags.toSpliced(tagIdx, 1));
    }
  });
